<template>
    <div>
        <div class="header-container-mobile">
                <img src="../../assets/logo-din-stad.png" class="logo-with-text-image-mobile" />
                <div class="menu-items-mobile">
                    <button @click="openSearchModal">
                        <i class="fas fa-search icon"></i>
                    </button>
                    <button @click="openSelectCityModal">
                        <i class="fas fa-map-marker-alt icon"></i>
                    </button>
                    <button @click="showNewsLetter">
                        <i class="fas fa-envelope icon"></i>
                    </button>
                    
                </div>
            </div>

        <b-modal v-model="isSelectCityModalOpen" size="lg" hide-header hide-footer @hidden="closeSearchModal"
        class="custom-modal">
            <EventstadenDropdownList :options="[]" @select="closeSelectCityModal"></EventstadenDropdownList>
        </b-modal>

        <b-modal v-model="isSearchModalOpen" size="lg" hide-header hide-footer @hidden="closeSearchModal"
            class="custom-modal">
            <SearchEvents placeholder="Sök evenemang..." @select="handleSearchSelect" />
        </b-modal>
    </div>
</template>


<script>
import SearchEvents from "../Search/SearchEvents.vue";
import localStorageService from "../../localStorageService/localStorageService.js";
import EventstadenDropdownList from "../../components/EventstadenDropdownList.vue";
import { EventBus } from '../../api/EventBusMixin';

export default {
    name: 'TabBar',
    components: {
        SearchEvents,
        EventstadenDropdownList
    },
    data() {
        return {
            isSearchModalOpen: false,
            isSelectCityModalOpen: false,
            showNewsLetterButton: true
        };
    },
    mounted() {
        this.showSubscribeView();
    },
    methods: {
        showSubscribeView() {
            const hideSubscribe = localStorageService.get("hide-subscribe");
            console.log("hideSubscribe");
            console.log(hideSubscribe);
            if (hideSubscribe) {
                this.showNewsLetterButton = !hideSubscribe;
            }
        },
        showNewsLetter()
        {
            EventBus.emit("showNewsLetter");
        },
        openAccountModal() {
            this.$emit('accountModal', { open: 'login-account' });
        },
        openSearchModal() {
            this.isSearchModalOpen = true; // Open the search modal
        },
        openSelectCityModal(){
            this.isSelectCityModalOpen = true;
        },
        closeSelectCityModal() {
            this.isSelectCityModalOpen = false;
        },
        closeSearchModal() {
            this.isSearchModalOpen = false; // Close the search modal
        },
        handleSearchSelect(selectedItem) {
            console.log("Selected Search Result:", selectedItem);
            this.closeSearchModal(); // Close the modal after selection
        },
    }
};
</script>

<style scoped>
/* .custom-modal .modal-content {
    background-color: #2d2f72 !important;
} */
.custom-modal {
    margin-top: 20px;
    /* Add top margin to create padding from the top */
    padding-top: 20px;
    /* Apply top padding to the modal content */
}

.header-container-mobile {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 40px;
}

.icon{
    color: white !important;
    font-size: 20px !important;
}

.menu-items-mobile button{
    background-color: transparent;
    border: none;
}

.menu-items-mobile {
    position: absolute;
    right: 20px;
    display: flex;
    gap: 10px;
}

.logo-with-text-image-mobile {
    position: fixed;
    left: -10px;
    height: 100px;
    margin-right: 5px;
    z-index: 1000;
}

.menu-options {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-grow: 1;
    margin-right: 20px;
}

.menu-item {
    background: none;
    border: none;
    cursor: pointer;
    padding: 10px;
    border-radius: 50%;
    color: white;
    font-size: 20px;
    transition: background 0.3s;
}
</style>
